import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'normalizeDate',
})
export class NormalizeDatePipe implements PipeTransform {
  transform(date: string | Date): string {
    if (!date) return '';

    const d = new Date(date);

    // Ajusta la fecha a la zona local para evitar desfasajes
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());

    // Formatea a DD/MM/AAAA
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  }
}
